(function() {
    'use strict';

    angular
        .module('app')
        .directive('drvSelectMenu', drvSelectMenu);

    drvSelectMenu.$inject = [];
    
    /**
     * @ngdoc directive
     * @name drvSelectMenu
     * 
     * @description
     * Creates a menu selection menu control
     * 
     * # Scope Properties
     * {string} label - Tooltip label
     * {string} colour - Text and icon colour. Optional.
     * {object} selectedValue - The selected value.
     * {array} options - The options which will be shown. Each option MUST have a label (string) and value (object) property.
     * {bool} disabled - Is the select menu disabled.
     * {function} onChange - Invoked when the selected value is changed. Note that the change does not have to be driven by this directive.
     */
    function drvSelectMenu() {
        var directive = {
            controller: drvSelectMenuCtrl,
            controllerAs: 'drvCtrl',
            restrict: 'E',
            scope: {},
            bindToController: {
                label: '<',
                colour: '<?',
                selectedValue: '=',
                options: '=',
                disabled: '<?',
                onChange: '&?'
            },
            template:
                '<md-menu-bar style="padding: 0px 0px 0px 0px; margin: 0px 0px 0px 0px;">' +
                '   <md-menu>' +
                '       <button ng-disabled="drvCtrl.disabled" drv-tool-tip="label" ng-click="$mdMenu.open(); drvCtrl.menuIcon = \'chevron up\';" style="background: none !important;">' +
                '          <span ng-style="{\'color\': drvCtrl.colour}">{{drvCtrl.selectedLabel}}</span>' +
                '          <drv-icon usage="drvCtrl.menuIcon" colour="drvCtrl.colour"></drv-icon>' +
                '       </button>' +
                '       <md-menu-content style="min-width: 0px;">' +
                '           <md-menu-item type="radio" ng-repeat="option in drvCtrl.options" ng-model="drvCtrl.selectedValue" ng-value="option.value">{{option.label}}</md-menu-item>' +
                '       </md-menu-content>' +
                '   </md-menu>' +
                '</md-menu-bar>'
        };

        drvSelectMenuCtrl.$inject = ['$scope', '$timeout'];

        return directive;

        function drvSelectMenuCtrl($scope, $timeout) {
            /* jshint validthis:true */
            var drvCtrl = this;
            Object.defineProperty(drvCtrl, 'selectedLabel', { get: getSelectedLabel });

            activate();

            function activate() {
                drvCtrl.menuIcon = 'chevron down';

                // When a md menu is closed, return the drop down icon to its original state.
                $scope.$on("$mdMenuClose", function () {
                    drvCtrl.menuIcon = 'chevron down';
                });

                $scope.$watch("drvCtrl.selectedValue", function (newVal, oldVal) {
                    if (newVal !== oldVal && !_.isNil(drvCtrl.onChange)) {
                        $timeout(function () {
                            drvCtrl.onChange();
                        });
                    }
                });
            }

            function getSelectedLabel() {
                var label = '';

                var selectedOption = _.find(drvCtrl.options, function (option) {
                    return option.value === drvCtrl.selectedValue;
                });

                if (!_.isNil(selectedOption)) {
                    label = selectedOption.label;
                }

                return label;
            }
        }
    }
})();